import FullPageLoading from '@/components/FullPageLoading';
import { VALIDATE_REQUIRED } from '@/config';
import { Form, Input, Row, Col, Checkbox, Button, InputNumber, message, Select, Spin } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { SaveOutlined } from '@ant-design/icons';
import { CreateUpdateLianeCommonSettingModel, PasswordPolicyDto } from '@/__generated';
import { apiSdk } from '@/httpClient';
import { ConfirmationBookingNotificationType } from '@/constants';

export default function GeneralConfiguration() {
  const [loading, setLoading] = React.useState<boolean>(true);
  const [settings, setSettings] = React.useState<CreateUpdateLianeCommonSettingModel>();
  const [updateLoadng, setUpdateLoading] = React.useState<boolean>(false);

  React.useMemo(() => {
    setLoading(true);
    apiSdk.LianeCommonSettingService.getSetting()
      .then(res => {
        setSettings(res);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);
  const { t } = useTranslation();

  const save = values => {
    setUpdateLoading(true);
    apiSdk.LianeCommonSettingService.update({ body: values })
      .then(res => {
        if (res.success) {
          message.success(t('accessControlPage_UpdateSucessMessage'));
        } else {
          message.error(t(res.message || ''));
        }
      })
      .finally(() => {
        setUpdateLoading(false);
      });
  };

  if (loading) {
    return <FullPageLoading loading={true} />;
  }
  return (
    <div style={{ maxWidth: 500 }}>
      <Spin spinning={updateLoadng}>
        <Form onFinish={save} size="middle" layout="vertical" initialValues={settings}>
          <Form.Item name="id" className="hidden">
            <Input type="hidden" />
          </Form.Item>
          <Row gutter={6}>
            <Col md={24}>
              <Form.Item
                label={t('passengerBookingPage_ConfirmationBookingNotification')}
                name="confirmationBookingNotification"
                rules={[{ required: true, message: VALIDATE_REQUIRED }]}
              >
                <Select options={ConfirmationBookingNotificationType.__getSelectOptions()} />
              </Form.Item>
            </Col>
            <Col md={24}>
              <Button type="primary" htmlType="submit" icon={<SaveOutlined />}>
                {t('save')}
              </Button>
            </Col>
          </Row>
        </Form>
      </Spin>
    </div>
  );
}
